"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTAINER_ID = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const notification_1 = __importDefault(require("@kawaui/notification"));
exports.CONTAINER_ID = 'notificationContainer';
const getContainer = () => document.getElementById(exports.CONTAINER_ID) || document.body;
const Notification = ({ open, onClose, i18n }) => {
    return ((0, jsx_runtime_1.jsx)(notification_1.default, { container: getContainer, duration: "min", onClose: onClose, open: open, variant: "error", children: i18n('cart_expired.error.recover') }));
};
exports.default = Notification;
